<template>
  <div class="header b_white">
    <div class="w1200 clear relative pad30_tb">
      <input type="hidden" id="isGoods" value="" />
      <h1 class="float-left">
        <a :href="`${app}`" class="float-left clear relative"><img src="./images/logo.png" height="54px" width="149px" /></a>
      </h1>
      <div class="float-left h_cont">
        <div class="d_search clear relative">
          <span class="d_query inlineblock relative">
            <i class="iconfont icon-sousuo-sousuo f16 gray_9"></i>
            <input type="text" placeholder="请输入货品或店铺名称" v-model="goodName" class="text f14" />
            <a href="#" class="b_red f16 white d_shp" @click="toGoodsSearchList">搜货品</a>
          </span>
          <a href="#" class="b_gray3 f16 white d_sdp" @click="toShopsSearchList">搜店铺</a>
        </div>
      </div>
      <div class="d_cart">
        <a :href="`${app}cart/selectCart.do`" class="f14 gray_3 h_mybugbox">
          <i class="iconfont icon-hnc_Mjinhuoche gray_8c mar5_r f16"></i>
          我的进货车
          <span class="f12 white" v-if="countCart > 0">{{ countCart }}</span>
        </a>
      </div>
    </div>
    <div class="h_navbox">
      <div class="h_nav w1200">
        <ul class="hrefList">
          <li class="hn_all">
            <a :href="`${app}goods/queryCategoryInfo.do`" class="f16 yahei all white"><i class="iconfont icon-fl vertical_m mar10_r"></i>全部货品分类</a>
          </li>
          <li class="cur">
            <a :href="`${app}recommend/activity/111`" target="_blank" class="f16 yahei">优选饲料</a>
          </li>
          <li><a :href="`${app}recommend/activity/109`" target="_blank" class="f16 yahei">兽药防疫</a></li>
          <li><a :href="`${app}recommend/internetOfThings`" target="_blank" class="f16 yahei">智能设备</a></li>
          <li><a :href="`${app}recommend/activity/144`" target="_blank" class="f16 yahei">易耗设备</a></li>
          <li><a href="https://www.gjszsc.com" target="_blank" class="f16 yahei">国家生猪市场</a></li>
          <li><a href="https://znt.com.cn/intelligent" target="_blank" class="f16 yahei">应用市场</a></li>
          <li><a href="https://www.huolianw.com/index.do" class="f16 yahei" target="_blank">农信货联</a></li>
          <li>
            <a :href="`${app}recommend/activity/135`" class="f16 yahei" target="_blank">农信直选</a>
          </li>
          <li>
            <a :href="`${app}recommend/activity/216`" class="f16 yahei nxjc_b" target="_blank">农信集采</a>
          </li>
          <li><a :href="`${app}goods/queryVipGoods.do`" target="_blank" class="f16 yahei">VIP商城</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      shop: {},
      shopList: [],
      showShopList: false,
      app: process.env.VUE_APP_APP,
      passport: process.env.VUE_APP_PASSPORT,
      goodName: "",
      countCart: 0,
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  mounted() {
    this.$nextTick(() => {
      this.getCountCart();
    });
  },
  methods: {
    switchoverShop() {
      this.showShopList = !this.showShopList;
    },
    selectShop(item) {
      this.$set(this.shop, "name", item.name);
    },
    getHeader() {
      this.$store.dispatch("header/getHeader", {}).then((data) => {
        if (!data) {
          return;
        }
        this.shop = data.shop || {};
        if (data.shopList && data.shopList.length > 0 && data.shop) {
          data.shopList.splice(
            data.shopList.findIndex((item) => item.shopIds === data.shop.shopIdStr),
            1
          );
        }
        this.shopList = data.shopList || [];
      });
    },
    getCountCart() {
      this.$store.dispatch("header/getCountCart", {}).then((data) => {
        this.countCart = data || 0;
      });
    },
    // 进入商品列表页
    toGoodsSearchList() {
      const goodName = encodeURI(this.goodName.trim());
      if (goodName.length > 0) {
        window.location.href = `${this.app}goods/queryGoodsInfo.do?name=${encodeURI(goodName)}`;
      }
    },
    // 进入店铺列表页
    toShopsSearchList() {
      // 搜索商铺
      const shopName = encodeURI(this.goodName.trim());
      if (shopName.length > 0) {
        window.location.href = `${this.app}goods/toShopList.do?name=${shopName}`;
      }
    },
  },
};
</script>
